import React from 'react';
import Container from 'react-bootstrap/Container';

import { PrivateSubmissionNavbar } from '../PrivateSubmissionNavbar/PrivateSubmissionNavbar';

import './style.scss';

interface IPrivateSubmissionLayoutProps {
  children: React.ReactNode;
  mainPadding?: boolean;
}

export default function PrivateSubmissionLayout({ children, mainPadding = true }: IPrivateSubmissionLayoutProps) {
  const currentYear = new Date().getFullYear();
  const mainClassName = mainPadding
    ? 'private-submission-layout__main'
    : 'private-submission-layout__main private-submission-layout__main--no-padding';

  return (
    <Container fluid className="private-submission-layout__container">
      <PrivateSubmissionNavbar />
      <main className={mainClassName}>{children}</main>
      <footer className="private-submission-layout__footer">
        © {currentYear} Comcate, Inc.
      </footer>
    </Container>
  );
}
